module.exports = __webpack_public_path__ + "static/media/ldi-poster.d67e894d.jpg";